export default "__VITE_ASSET__CxtTXMFs__"